import React from 'react'
import { LogEntry } from '../types'
import { formatLogMessage } from '../services/formatLogMessage'
import HighlightText from './HighlightText'
import useStyles from '../styles'

interface LogMessageCellProps {
  entry: LogEntry
  searchTerm?: string
}

const LogMessageCell: React.FC<LogMessageCellProps> = ({
  entry,
  searchTerm = '',
}) => {
  const classes = useStyles()
  const message = formatLogMessage(entry)

  return (
    <div
      className={classes.logMessageCell}
      title={entry.description}
    >
      <span className={classes.logMessageText}>
        <HighlightText
          text={message.text}
          query={searchTerm}
        />
      </span>
    </div>
  )
}

export default LogMessageCell
